import { render, staticRenderFns } from "./ChatsList.vue?vue&type=template&id=3631f731&scoped=true"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"
import style0 from "./ChatsList.vue?vue&type=style&index=0&id=3631f731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631f731",
  null
  
)

export default component.exports